<div class="navHeader col-12 bg-primary position-fixed">
  <h2 class="d-inline-block">{{heading}}</h2>
  <span class="header-breadcrumb" *ngFor="let crumb of breadcrumbs">{{crumb}}</span>
  <div class="float-right">
    <user-info></user-info>
  </div>
</div>
